import React from "react";
import { Alert, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store";
import { formatSnapshotTimestamp } from "../../store/storyline/snapshots";
import { Markdown } from "../../shared/components/Markdown";

export function SnapshotBanner() {
    const snapshot = useSelector((state: RootState) => state.storyline.snapshot);
    const navigate = useNavigate();

    if (!snapshot) return null;

    return (
        <Alert
            id="snapshot-banner"
            className="Qerent-notification-banner"
            severity="info"
            action={
                <Button color="info" variant="contained" size="small" onClick={() => navigate(snapshot.capturedUrl)}>
                    View live version
                </Button>
            }
        >
            <div>
                <Markdown content={`**Snapshot${snapshot.name ? ": " + snapshot.name : ""}**  |  Captured at <code>${formatSnapshotTimestamp(snapshot.capturedAt)}</code> by <code>${snapshot.owner}</code>`} />
            </div>
            <div className="text-smallest">
                
                <strong>NOTE:</strong>&nbsp;
                Interactivity is limited while viewing snapshots.
            </div>
        </Alert>
    );
}
